// extracted by mini-css-extract-plugin
module.exports = {"alt-wrapper":"AltPageWrapper_alt-wrapper__1Y67Q","alt-wrapper__inner":"AltPageWrapper_alt-wrapper__inner__xsogd"};